import styled from 'styled-components';

export const PostContainer = styled.div`
  width: 85%;
  float: left;
`;

export const ContentContainer = styled.div`
  width: 95%;
  margin: 0 auto;
  position: relative;
`;
